module.exports = __webpack_public_path__ + "static/img/heart.6f35abeb.png";